export enum SizeClass {
  COMPACT = "compact",
  REGULAR = "regular",
  WIDE = "wide",
}
